import dayjs from 'dayjs';
import KpiWeight from './KpiWeight.js';
import KpiMeasure from '../enums/KpiMeasure.js';

export default class Kpi {
  constructor(data) {
    this.id = data?.id;
    this.name = data?.name;
    this.measure = data?.measure ? KpiMeasure.of(data.measure) : null;
    this.baseValue = data?.baseValue ? Number(data.baseValue) : null;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.kpiWeights = data?.kpiWeights ? data?.kpiWeights.map(k => new KpiWeight(k)) : [];
  }
}
